var _g, _g2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_470_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14C6 8.47715 10.4772 4 16 4H44C49.5228 4 54 8.47715 54 14V42C54 47.5228 49.5228 52 44 52H16C10.4772 52 6 47.5228 6 42V14Z",
    fill: "url(#paint0_linear_470_2283)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_470_2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 11.7218C10.6961 9.63485 12.783 5.46094 21.6513 5.46094C29.094 5.46094 33.7331 5.46094 39.3276 5.46094C44.9222 5.46094 49.4091 8.41746 50.9743 11.7218",
    stroke: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9474 22.9474V38.7368C39.9474 39.4347 39.3821 40 38.6842 40H22.2632C21.5653 40 21 39.4347 21 38.7368V17.2632C21 16.5653 21.5653 16 22.2632 16H33L34.8947 21.0526L39.9474 22.9474Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 16V21.6842C33 22.3821 33.5653 22.9474 34.2632 22.9474H39.9474L33 16Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_470_2283",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_470_2283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_470_2283",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_470_2283",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.0605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_470_2283"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_2283",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.173913,
    stopColor: "#0A8BFE",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A8BFE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogWriting);
export default __webpack_public_path__ + "static/media/blog_writing.dd250e29997918a6190248542a80ea00.svg";
export { ForwardRef as ReactComponent };